import { ArchiveItem } from "@/features/archive/components/lists/ArchiveItem";
import type { ArchiveThread } from "@/features/archive/types";
import { MobileCatalogGridLayout } from "@/features/catalog/components/lists/MobileCatalogGridLayout";
import { Message } from "@/shared/ui/feedback";

interface ArchiveGridProps {
  threads: ArchiveThread[];
  columns: number;
  emptyMessage?: string;
}

export const ArchiveGrid: React.FunctionComponent<ArchiveGridProps> = ({
  threads,
  columns,
  emptyMessage = "過去ログはまだありません",
}: ArchiveGridProps) => {
  if (threads.length === 0) {
    return <Message variant="info">{emptyMessage}</Message>;
  }

  return (
    <MobileCatalogGridLayout columns={columns}>
      {threads.map((thread) => (
        <ArchiveItem key={thread.threadId} thread={thread} />
      ))}
    </MobileCatalogGridLayout>
  );
};
